import React from "react";

export default function AppBridgeProvider({ children }) {
  // App Bridge v4: No provider needed, components connect directly to app-bridge.js
  return <>{children}</>;
}

